
/**
 * import react
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui/core
 */
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

/**
 * import utility functions
 */
import { constVal } from '../slot-const';

const MessageDialog = (props = {}) => {
  const getActionButtons = () => {
    switch (props.type) {
    case constVal.MSG_TYPE_CONFIRMATION:
      return (
        <div>
          <Button color="primary" onClick={props.handleOkOnClick}>Yes</Button>
          <Button color="primary" onClick={props.handleCancelOnClick}>No</Button>
        </div>
      );
    case constVal.MSG_TYPE_PROGRESS:
      return (
        null
      );
    default:
    case constVal.MSG_TYPE_INFORMATION:
    case constVal.MSG_TYPE_ERROR:
      return (
        <Button color="primary" onClick={props.handleCancelOnClick}>Close</Button>
      );
    }
  };

  const getContent = () => {
    const { content = '', contentList = [] } = props;
    let ret = null;
    if (content) {
      ret = (
        <DialogContentText>
          <span style={{ fontSize: '1rem' }}>{content}</span>
        </DialogContentText>
      );
    } else if (contentList) {
      ret = (
        <Grid container>
          <Grid item>
            <List>
              {contentList.map(({ key }, idx) => {
                return (
                  <ListItem key={idx}>
                    <ListItemText>{key}</ListItemText>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
          <Grid item>
            <List>
              {contentList.map(({ val }, idx) => {
                return (
                  <ListItem key={idx}>
                    <ListItemText>{val ? `: ${val}` : ': -'}</ListItemText>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      );
    }
    return ret;
  };

  return (
    <Dialog open={true} maxWidth="lg">
      <DialogTitle>{props.title || props.type}</DialogTitle>
      <DialogContent>
        {getContent()}
      </DialogContent>
      <DialogActions>
        {getActionButtons()}
      </DialogActions>
    </Dialog>
  );
};

MessageDialog.propTypes = {
  type: PropTypes.string.isRequired,
  handleCancelOnClick: PropTypes.func,
  content: PropTypes.string,
  title: PropTypes.string,
  handleOkOnClick: PropTypes.func,
  contentList: PropTypes.array
};

export default MessageDialog;
